// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-detail {
    margin: 15px auto;
}

.store-detail__h1 {
    font-size: var(--font-xl);
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin: 15px auto;
    text-align: center;
    padding: 0 15px;
}

.store-detail__buttons {
    padding: 15px;
    text-align: center;
}

.store-detail__wrapper {
    display: flex;
    flex-direction: column;
    gap: 30px;
    margin: 30px 0;
    padding: 0 15px;
    box-sizing: border-box;
}

.store-detail__header {
    display: flex;
    flex-direction: row;
    justify-content: stretch;
}

.store-detail__map {
    flex: 1 1 50%;
    aspect-ratio: 1 / 1;
}

.store-detail__info {
    flex: 1 1 auto;
    padding: 15px;
    box-sizing: border-box;
}


.store-detail__info-wrapper {
    display: block;
}

.store-detail__address {
    margin: 15px;
}

.store-detail__workhours {
    margin: 15px;
}

.store-detail__phone {
    display: block;
    padding: 30px 15px;
    font-size: var(--font-l);
    text-decoration: none !important;
    outline: none !important;
    color: var(--color-granite) !important;
}

.store-detail__info-buttons {
}

.store-detail__button {
    display: inline-block;
}

.store-detail__photos {
    box-sizing: border-box;
}

.store-detail__photos-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
}

.store-detail__photo {
    flex: 1 1 calc(25% - 15px);
    max-width: calc(25% - 15px);
    aspect-ratio: 1 / 1;
    display: flex;
}

.store-detail__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

@media screen and (max-width: 1024px) {

    .store-detail__header {
        flex-direction: column;
        align-items: stretch;
    }

    .store-detail__info {
        order: 1;
    }

    .store-detail__map {
        flex: 1 1 auto;
        order: 2;
    }

    .store-detail__photos-wrapper {
        display: block;
    }

    .store-detail__photos-wrapper .f-carousel__dots {
        display: none !important;
    }

    .store-detail__photo {
        display: block;
        flex: 0 0 auto;
        /*width: 100%;*/
        max-width: none;
    }
}


`, "",{"version":3,"sources":["webpack://./resources/views/site/pages/store/main.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;AACA;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;IAEI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,cAAc;QACd,QAAQ;IACZ;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;QACd,cAAc;QACd,eAAe;QACf,eAAe;IACnB;AACJ","sourcesContent":[".store-detail {\n    margin: 15px auto;\n}\n\n.store-detail__h1 {\n    font-size: var(--font-xl);\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin: 15px auto;\n    text-align: center;\n    padding: 0 15px;\n}\n\n.store-detail__buttons {\n    padding: 15px;\n    text-align: center;\n}\n\n.store-detail__wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    margin: 30px 0;\n    padding: 0 15px;\n    box-sizing: border-box;\n}\n\n.store-detail__header {\n    display: flex;\n    flex-direction: row;\n    justify-content: stretch;\n}\n\n.store-detail__map {\n    flex: 1 1 50%;\n    aspect-ratio: 1 / 1;\n}\n\n.store-detail__info {\n    flex: 1 1 auto;\n    padding: 15px;\n    box-sizing: border-box;\n}\n\n\n.store-detail__info-wrapper {\n    display: block;\n}\n\n.store-detail__address {\n    margin: 15px;\n}\n\n.store-detail__workhours {\n    margin: 15px;\n}\n\n.store-detail__phone {\n    display: block;\n    padding: 30px 15px;\n    font-size: var(--font-l);\n    text-decoration: none !important;\n    outline: none !important;\n    color: var(--color-granite) !important;\n}\n\n.store-detail__info-buttons {\n}\n\n.store-detail__button {\n    display: inline-block;\n}\n\n.store-detail__photos {\n    box-sizing: border-box;\n}\n\n.store-detail__photos-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n}\n\n.store-detail__photo {\n    flex: 1 1 calc(25% - 15px);\n    max-width: calc(25% - 15px);\n    aspect-ratio: 1 / 1;\n    display: flex;\n}\n\n.store-detail__img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n@media screen and (max-width: 1024px) {\n\n    .store-detail__header {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .store-detail__info {\n        order: 1;\n    }\n\n    .store-detail__map {\n        flex: 1 1 auto;\n        order: 2;\n    }\n\n    .store-detail__photos-wrapper {\n        display: block;\n    }\n\n    .store-detail__photos-wrapper .f-carousel__dots {\n        display: none !important;\n    }\n\n    .store-detail__photo {\n        display: block;\n        flex: 0 0 auto;\n        /*width: 100%;*/\n        max-width: none;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
